// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ZenChartComboFunction extends React.Component {
  state = {
    mainData: null,
    
    ZenVerBarChartA: null,
    ZenVerBarChartB: null,
    ZenVerBarChartC: null,

   

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
    selectedGraphParams: {},
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", this.props.urlData || {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("ZenChart ComboFunction");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  onGraphClick = ({ apiUrl, urlData, changeKey }) => {
    this.setState({
      ...this.state,
      dataLoading: true
    })
    let params = Object.keys(this.state.selectedGraphParams).length
      ? { ...this.state.selectedGraphParams }
      : { ...urlData };
    if (this.state.selectedGraphParams[changeKey] === urlData[changeKey]) {
      params[changeKey] = "all";
    } else {
      params[changeKey] = urlData[changeKey];
    }
    this.setState({
      ...this.state,
      selectedGraphParams: params,
    });
    liracrypt
      .get(apiUrl, params)
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        
        respData["ZenVerBarChartA"] = resp["data"]["ZenVerBarChartA"];
        respData["ZenVerBarChartB"] = resp["data"]["ZenVerBarChartB"];
        respData["ZenVerBarChartC"] = resp["data"]["ZenVerBarChartC"];


       
        respData["mainData"] = { ...resp };
        this.setState(
          {
            ...this.state,
            ...respData,
            loading: false,
            dataLoading: false,
          },
          () => { }
        );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  fetchTrendData = (selectedTab, lid = "all", mnt = "all", sh = "all") => {
    liracrypt
      .get("/chartdatacombo", {
        lid,
        mnt,
        sh,
        typ: "MainGraph",
        subTyp: selectedTab,
        dn: "TemplateZenChartFunctions",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
    

        respData["ZenVerBarChartA"] = resp["data"]["ZenVerBarChartA"];
        respData["ZenVerBarChartB"] = resp["data"]["ZenVerBarChartB"];
        respData["ZenVerBarChartC"] = resp["data"]["ZenVerBarChartC"];


        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  graphLoader() {
    return (
      <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', width: 'inherit', height: 'inherit' }}>
        <Spin indicator={antIcon} />
      </div>
    )
  }

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
          ? "all"
          : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>

{/* ____________________________________START_____________________________________ */}

   

                <Row style={{ background: "#000000" }}>
                  <div
                    style={{
                      borderRadius: "10px",
                      background: "#191C24",
                      border: "1px solid #3c3e4f",
                      margin: "10px 0px 0px 10px",
                      height: "320px",
                      width: "350px",
                    }}
                  >
                    {
                      this.state.dataLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                          <Spin indicator={antIcon} />
                        </div> :
                        <ZenVerBarChart
                          divId={"ZenVerBarChartA"}
                          data={this.state.ZenVerBarChartA.data}
                          config={this.state.ZenVerBarChartA.config}
                          onChange={(data) => this.onGraphClick(data)}
                        />
                    }
                  </div>
                  <div
                    style={{
                      borderRadius: "10px",
                      background: "#191C24",
                      border: "1px solid #3c3e4f",
                      margin: "10px 0px 0px 10px",
                      height: "320px",
                      width: "350px",
                    }}
                  >
                    <p>{this.state.selectedGraphId}</p>
                    {
                      this.state.dataLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                          <Spin indicator={antIcon} />
                        </div> :
                        <ZenVerBarChart
                          divId={"ZenVerBarChartB"}
                          data={this.state.ZenVerBarChartB.data}
                          config={this.state.ZenVerBarChartB.config}
                          onChange={(data) => this.onGraphClick(data)}
                        />
                    }
                  </div>
                  <div
                    style={{
                      borderRadius: "10px",
                      background: "#191C24",
                      border: "1px solid #3c3e4f",
                      margin: "10px 0px 0px 10px",
                      height: "320px",
                      width: "350px",
                    }}
                  >
                    {
                      this.state.dataLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                          <Spin indicator={antIcon} />
                        </div> :
                        <ZenVerBarChart
                          divId={"ZenVerBarChartC"}
                          data={this.state.ZenVerBarChartC.data}
                          config={this.state.ZenVerBarChartC.config}
                          onChange={(data) => this.onGraphClick(data)}
                        />
                    }
                  </div>
                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ZenChartComboFunction;
